/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import Link from 'next/link';
import BSPagination from 'react-bootstrap/Pagination';
import styles from './Pagination.module.scss';
import type * as Types from './types';

export const ApiPagination = ({ items, relative }: Types.ApiPagination) => {
  const hasPrevPage = !!relative?.prev?.urlSet?.api;
  const hasNextPage = !!relative?.next?.urlSet?.api;
  const showPagination = hasPrevPage || hasNextPage || items?.length > 1;

  return showPagination ? (
    <div className={styles.paginationContainer} data-testid="catalog:pagination">
      <BSPagination>
        <Link href={relative?.prev?.urlSet?.web ?? '#'} legacyBehavior passHref>
          <BSPagination.Prev disabled={!hasPrevPage} />
        </Link>
        {items?.length > 1 &&
          items.map((item: Types.ApiPaginationItem, idx: number) => {
            if (item.isSeparator) {
              return <BSPagination.Ellipsis key={idx} disabled />;
            }

            return (
              <Link href={item.urlSet.web} legacyBehavior passHref key={idx}>
                <BSPagination.Item active={item?.selected}>{item.label}</BSPagination.Item>
              </Link>
            );
          })}
        <Link href={relative?.next?.urlSet?.web ?? '#'} legacyBehavior passHref>
          <BSPagination.Next disabled={!hasNextPage} />
        </Link>
      </BSPagination>
    </div>
  ) : null;
};
